import React from 'react';
import { connect } from 'react-redux';

import HeadingBox from '../../UI/Headings/HeadingBox/HeadingBox';
import HeadingH2 from '../../UI/Headings/HeadingH2/HeadingH2';
import HeadingH3 from '../../UI/Headings/HeadingH3/HeadingH3';
import Button from '../../UI/Button/Button';

import LinkSentImage from './img/link-sent.png';

import { setAuthView } from '../../../store/actions/index';

const authResetPasswordLink = (props) => (
    <React.Fragment>
        <div className={`mb-8 u-phoneTextAlignCenter`}>
            <HeadingBox>
                <HeadingH2 size={26} weight="Regular" color="Dark">Link Sent Successfully!</HeadingH2>
                <div className={`mb-4`}>
                    <HeadingH3 size={13} weight="Regular" color="Light">A link to reset your password has been sent to your <span className={`u-textColorDark`}>Email ID: {props.email}</span></HeadingH3>
                </div>
                <div className={`mb-4`}>
                    <HeadingH3 size={13} weight="Regular" color="Light">Please folow the steps mentioned in email to reset the password</HeadingH3>
                </div>
            </HeadingBox>
        </div>
        <div className={`mb-8`}>
            <img src={LinkSentImage} alt='Link Sent Successfully!'/>
        </div>
        <div className={`mb-4`}>
            <Button theme='Primary' width='Block' type='Login' onClick={() => props.onSetAuthView('home')}>PROCEED TO LOGIN</Button>
        </div>
        <div>
            <HeadingH3 size={13} weight="Regular" color="Light"><span className={`u-textColorDark`}>Note:</span>In case you do not find the email in your inbox, please check spam folder.</HeadingH3>
        </div>
    </React.Fragment>
);

const mapStateToProps = state => {
    return {
        email: state.auth.email
    }
}

const mapDispatchToProps = dispatch => {
    return {
        onSetAuthView: (view) => dispatch(setAuthView(view))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(authResetPasswordLink);


// WEBPACK FOOTER //
// ./src/components/Authentication/AuthResetPasswordLink/AuthResetPasswordLink.js